import { useState } from 'react'

export default function useLoadingState() {
  const [loaders, setLoaders] = useState({})

  const startLoading = (key) => setLoaders((prev) => ({ ...prev, [key]: true }))
  const stopLoading = (key) => setLoaders((prev) => ({ ...prev, [key]: false }))
  const isLoading = (key) => !!loaders[key]

  const withLoading = (key, asyncFunction) => async (...args) => {
    startLoading(key)
    try {
      return await asyncFunction(...args)
    } finally {
      stopLoading(key)
    }
  }

  return { isLoading, startLoading, stopLoading, withLoading }
}
